// Rohini 02/09/2023 2698964415 Added the notification icon

import React from 'react';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  makeStyles,
  Popover,
  Tooltip,
  useTheme,
} from '@material-ui/core';
import PerfectScrollbar from 'react-perfect-scrollbar';
import clsx from 'clsx';
import Badge from '@material-ui/core/Badge';
import Typography from '@material-ui/core/Typography';
import LanguageItem from '../../@coremat/CmtList/LanguageItem';
import CmtList from '../../@coremat/CmtList/CmtList';
import NotificationsOutlinedIcon from '@material-ui/icons/NotificationsOutlined';
const useStyles = makeStyles((theme) => ({
  cardRoot: {
    '& .MuiCardHeader-root': {
      borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    },

    '& .MuiCardHeader-title': {
      fontSize: 16,
      fontWeight: 'bold',
      lineHeight: 1.235,
    },
    '& .MuiCardContent-root': {
      padding: 0,
    },
    '& .MuiBox-root': {
      fontSize: 14,
      fontWeight: 400,
      lineHeight: 1.334,
    },
  },
  typography: {
    padding: theme.spacing(2),
  },
  iconRoot: {
    'position': 'relative',
    'color': theme.palette.common.white,
    '&:hover, &.active': {
      color: theme.palette.common.white,
    },
  },
  counterRoot: {
    color: theme.palette.common.white,
    border: `solid 1px ${theme.palette.common.white}`,
    backgroundColor: theme.palette.warning.main,
    width: 20,
  },
  scrollbarRoot: {
    maxHeight: 300,
  },
  popoverRoot: {
    '& .MuiPopover-paper': {
      width: 375,
    },
  },
  headerRoot: {
    padding: 14,
  },
}));

const actions = [
  {
    label: 'More Detail',
  },
  {
    label: 'Close',
  },
];

const HeaderNotifications = () => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [counter, setCounter] = React.useState(1);
  const theme = useTheme();

  const onOpenPopOver = (event) => {
    setAnchorEl(event.currentTarget);
    setCounter(0);
  };

  const onClosePopOver = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const headerNotifications = [
    {
      item: 0,
      value: 'New record added in the work queue',
    },
  ];

  return (
    <Box>
      <Tooltip title="Notifications">
        <IconButton
          onClick={onOpenPopOver}
          className={clsx(classes.iconRoot, 'Cmt-appIcon', {
            active: counter > 0,
          })}
        >
          <Badge badgeContent={0} classes={{badge: classes.counterRoot}} overlap="rectangular">
            <NotificationsOutlinedIcon />
          </Badge>
        </IconButton>
      </Tooltip>

      <Popover
        className={classes.popoverRoot}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={onClosePopOver}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Card className={classes.cardRoot}>
          <CardHeader
            className={classes.headerRoot}
            title="Notifications"
            actionspos="top-corner"
            actions={actions}
            separator={{
              color: theme.palette.borderColor.dark,
              borderWidth: 1,
              borderStyle: 'solid',
            }}
          />
          <CardContent>
            {headerNotifications.length > 0 ? (
              <PerfectScrollbar className={classes.scrollbarRoot}>
                <CmtList
                  data={headerNotifications}
                  renderRow={(item, index) => (
                    <LanguageItem key={index} searchItem={item} onClick={onClosePopOver} />
                  )}
                />
              </PerfectScrollbar>
            ) : (
              <Box p={6}>
                <Typography variant="body2">No notifications found</Typography>
              </Box>
            )}
          </CardContent>

        </Card>
      </Popover>
    </Box>
  );
};

export default HeaderNotifications;
